const TRANSITION_DURATION_MS = 150;
const wrapperCls = "_yr2w12yxn2s";
const iframeCls = "_yr2i12ce5tn";
const throbberCls = "_yr2t1q46t9q";

export { TRANSITION_DURATION_MS, iframeCls, throbberCls, wrapperCls };
import "./postloaded-iframe.style.linaria.module.css";
//# sourceMappingURL=postloaded-iframe.style.js.map
